import { CloseRounded, FilterList } from '@mui/icons-material';
import { IconButton, IconButtonProps, Typography } from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';
import { forwardRef, PropsWithChildren } from 'react';

interface Props {
  showFilters: boolean;
  buttonHeight?: number;
  toggleFilters: () => void;
}

const ToggleFiltersButtonBase = (
  { showFilters, toggleFilters, buttonHeight, ...rest }: PropsWithChildren<IconButtonProps & Props>,
  ref: IconButtonProps['ref']
) => {
  const t = useAppTFunction();
  return (
    <IconButton
      {...rest}
      ref={ref}
      sx={{
        border: '1.5px solid',
        borderColor: 'divider',
        borderRadius: 2,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        height: buttonHeight ?? '40.02px',
        borderBottom: 0,
        bgcolor: showFilters ? 'background.paper' : undefined,
        mb: -1.1,
        ...rest.sx,
      }}
      onClick={toggleFilters}
    >
      {showFilters ? (
        <CloseRounded sx={{ color: 'text.secondary' }} fontSize="small" />
      ) : (
        <FilterList sx={{ color: 'text.secondary' }} fontSize="small" />
      )}
      <Typography variant="body2">{t('myAssortment.filter.filter')}</Typography>
    </IconButton>
  );
};
const ToggleFiltersButton = forwardRef(ToggleFiltersButtonBase);
export default ToggleFiltersButton;
